const setCookie = (name: string, value: string) => {
  document.cookie = value !== undefined ? `${name}=${value}; Path=/` : `${name}=`;
};

const readCookie = (name: string) => {
  const cookie: string = document.cookie
    .split(";")
    .map((cookieStr) => cookieStr.trim())
    .find((cookieStr) => cookieStr.startsWith(name));

  return cookie && cookie.replace(`${name}=`, "");
};

export const CookieHelper = {
  setCookie,
  readCookie
};
